import React from 'react';
import { HiEye, HiX } from 'react-icons/hi';

const GhostModeBanner = ({ ghostedUser, onExit }) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[50] h-14 bg-yellow-500 text-gray-900 shadow-lg flex items-center">
      <div className="w-full px-3 sm:px-6">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 min-w-0">
            <HiEye className="w-4 h-4 flex-shrink-0" />
            <span className="font-semibold text-sm whitespace-nowrap">Ghost Mode:</span>
            <span className="text-sm truncate">
              <strong>{ghostedUser?.email || 'Unknown User'}</strong>
              {ghostedUser?.firstname && ghostedUser?.lastname && (
                <span className="hidden sm:inline ml-1">
                  ({ghostedUser.firstname} {ghostedUser.lastname})
                </span>
              )}
            </span>
          </div>
          <button
            onClick={onExit}
            className="flex-shrink-0 flex items-center gap-1.5 px-3 py-1.5 bg-gray-900 text-white rounded-md hover:bg-gray-800 transition-colors text-sm font-medium"
          >
            <HiX className="w-4 h-4" />
            <span className="hidden sm:inline">Exit Ghost Mode</span>
            <span className="sm:hidden">Exit</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GhostModeBanner;
